import { Component } from "react"

/* Mask */
import InputMask from "@mona-health/react-input-mask"

/* Components */
import Icon from "./Icon"


/* Component Input — one field of a form. The name of the field lives inside the frame: it stands
   in the middle while the field is empty and rises to the top as soon as it is filled, so it
   never covers what was typed and needs no colour of the background under it.

   Props: label, value, onChange, mask, secure, file, textarea, disabled, icon, hint, maxLength.
   The error is shown from the outside by the reference — this._name.error("Введите название") */
class Input extends Component {

    constructor() {
        super()

        this.state = {
            focused: false,
            secured: true,
            error: ""
        }
    }

    /* Show Error */
    error = error => this.setState({ error })

    /* On Focus */
    focus = () => {

        const { clear, onFocus } = this.props

        if (clear !== null && clear !== undefined) {
            clear()
        }

        this.setState({ focused: true, error: "" })

        if (onFocus) {
            onFocus()
        }
    }

    /* On Blur */
    blur = () => {

        const { clear, onBlur } = this.props

        if (clear !== null && clear !== undefined) {
            clear()
        }

        this.setState({ focused: false })

        if (onBlur) {
            onBlur()
        }
    }

    /* Put the caret into the field when the name of it is clicked */
    press = () => {

        if (this._input && this._input.focus) {
            this._input.focus()
        }
    }

    /* The field itself — a line, a line with a mask or a box of several lines */
    _field = () => {

        /* Fields */
        const { value, label, secure, file, textarea, mask, rows, clear, icon, hint, onFocus, onBlur, ...props } = this.props
        const { secured } = this.state

        const shared = {
            ...props,
            onFocus: () => this.focus(),
            onBlur: () => this.blur(),
            ref: ref => this._input = ref
        }

        /* A box of several lines — the description of a point is written in it */
        if (textarea) {
            return <textarea {...shared} value={value} rows={rows ? rows : 3} />
        }

        /* A line with a mask — the telephone */
        if (mask) {
            return <InputMask {...shared} mask={mask} value={value} type={secure && secured ? "password" : "text"} />
        }

        /* A file is chosen and not typed */
        if (file) {
            return <input {...shared} type="file" />
        }

        return <input {...shared} value={value} type={secure && secured ? "password" : "text"} />
    }

    render = () => {

        /* Fields */
        const { value, label, secure, file, textarea, disabled, icon, hint, maxLength } = this.props
        const { focused, error, secured } = this.state

        /* A field which is only read */
        if (disabled) {
            return (
                <div className="input disabled">
                    <div className="input-field filled">
                        <div className="input-label">{label}</div>
                        <div className="input-value">{value}</div>
                    </div>
                </div>
            )
        }

        /* The name of the field rises as soon as there is something under it */
        const filled = file || focused || (value !== undefined && value !== null && `${value}`.length > 0)

        /* How much of the allowed length is written */
        const counter = maxLength && value !== undefined && value !== null ? `${`${value}`.length} / ${maxLength}` : null

        return (
            <div className={`input ${error ? "error" : ""} ${focused ? "focused" : ""} ${textarea ? "textarea" : ""}`}>

                <div className={`input-field ${filled ? "filled" : ""} ${icon ? "with-icon" : ""} ${secure ? "with-action" : ""}`}>

                    {icon &&
                        <div className="input-icon">
                            <Icon name={icon} size={18} />
                        </div>
                    }

                    <div onClick={() => this.press()} className="input-label">{label}</div>

                    {this._field()}

                    {secure &&
                        <div onClick={() => this.setState({ secured: !secured })} className="input-action">
                            <Icon name={secured ? "eye" : "eyeOff"} size={18} />
                        </div>
                    }

                </div>

                {error !== "" &&
                    <div className="input-error">
                        <Icon name="alert" size={13} width={2.2} />
                        <span>{error}</span>
                    </div>
                }

                {error === "" && (hint || counter) &&
                    <div className="input-bottom">
                        <span>{hint}</span>
                        {counter && <span className="input-counter">{counter}</span>}
                    </div>
                }

            </div>
        )
    }
}

export default Input
